/**
 * InspectionProvider — UMA instância de useInspection compartilhada por
 * todas as páginas do fluxo cliente (placa → captura → vídeo → upload →
 * status). Sem isso, cada página criava estado próprio e a placa/fotos/
 * vídeo capturados nunca chegavam à página de upload.
 *
 * Também liga o X-Api-Key (useApiKey → localStorage) e o device_id
 * persistido a TODAS as chamadas do fluxo.
 */
import React, { createContext, useContext } from 'react';
import { useInspection, type UseInspectionReturn } from './useInspection';
import { useApiKey, useDeviceId } from './useApiKey';

const InspectionContext = createContext<UseInspectionReturn | null>(null);

export const InspectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { apiKey } = useApiKey();
  const deviceId = useDeviceId();

  const inspection = useInspection({
    deviceId: deviceId || 'web-client',
    appVersion: '1.0.0',
    apiKey: apiKey ?? undefined,
  });

  return (
    <InspectionContext.Provider value={inspection}>
      {children}
    </InspectionContext.Provider>
  );
};

export function useInspectionContext(): UseInspectionReturn {
  const ctx = useContext(InspectionContext);
  if (!ctx) {
    throw new Error('useInspectionContext deve ser usado dentro de <InspectionProvider>');
  }
  return ctx;
}
